import { render } from "./ClassicalNavigation.vue?vue&type=template&id=0270e7e2"
import script from "./ClassicalNavigation.vue?vue&type=script&lang=js"
export * from "./ClassicalNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__